export class Modal {
	/**
	 * Initialize modal functionality
	 */
	constructor() {
		this.modals = document.querySelectorAll(".modal");
		this.triggers = document.querySelectorAll("[data-modal-target]");

		this.init();
	}

	/**
	 * Initialize all modals
	 * @private
	 * @returns {void}
	 */
	init() {
		this.triggers.forEach((trigger) => this.setupTrigger(trigger));
		this.modals.forEach((modal) => this.setupModal(modal));
	}

	/**
	 * Set up click handler for a modal trigger
	 * @private
	 * @param {HTMLButtonElement} trigger
	 * @returns {void}
	 */
	setupTrigger(trigger) {
		trigger.addEventListener("click", () => {
			const modalId = trigger.dataset.modalTarget;
			const modal = document.getElementById(modalId);

			if (modal) {
				modal.showModal();
				// Safari workaround: force focus to modal for proper keyboard nav
				modal.tabIndex = -1;
				modal.focus();
				modal.removeAttribute("tabindex");
			}
		});
	}

	/**
	 * Set up modal close handlers
	 * @private
	 * @param {HTMLDialogElement} modal
	 * @returns {void}
	 */
	setupModal(modal) {
		// Close button
		const closeButton = modal.querySelector(".modal__close");
		if (closeButton) {
			closeButton.addEventListener("click", () => modal.close());
		}

		// Click on backdrop to close
		modal.addEventListener("click", (e) => {
			if (e.target === modal) {
				modal.close();
			}
		});
	}
}
